module.exports = __webpack_public_path__ + "img/horizontal_7_2_8019.b2b40d8f.png";